import { c as _c } from "react/compiler-runtime";
import { InputWrapper, SelectWrapper } from "@/src/components/tasks/input-wrapper";
import { EntityMatcher } from "@/src/components/tasks/intake-sections/matchers";
import { Hyperlink } from "@/src/components/typography";
import { EnabledFields } from "@/src/lib/schema-types";
import { enumToOptions, getNestedValue, isFieldEnabled } from "@/src/lib/utils/object-utils";
import { type Practitioner, type PractitionerErrors, PractitionerRole } from "@/src/models/practitioner";
interface ProviderFormProps {
  // Base props
  provider: Practitioner | null;
  onChange: (field: keyof Practitioner, value: string) => void;
  createMode?: boolean;

  // practitioner-card-editable props
  errors?: PractitionerErrors;

  // provider-section props
  providerObjString?: string;
  requiredFields?: string[];
  enabledFields?: EnabledFields;
  onSave?: () => void;
  onFocus?: (metadata?: any) => void;
  metadata?: any;

  // ProviderEntityMatcher props
  practitioners?: Practitioner[];
  loading?: boolean;
  onProviderSelected?: (provider: Practitioner | null) => void;
  showProviderMatcher?: boolean;
  onEmptyToggle?: () => void;
}
export default function ProviderForm(t0) {
  const $ = _c(36);
  const {
    provider,
    onChange,
    createMode: t1,
    errors: t2,
    providerObjString,
    requiredFields: t3,
    enabledFields,
    onSave,
    onFocus,
    metadata,
    practitioners,
    loading,
    onProviderSelected,
    showProviderMatcher: t4,
    onEmptyToggle
  } = t0;
  const createMode = t1 === undefined ? false : t1;
  let t5;
  if ($[0] !== t2) {
    t5 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const errors = t5;
  let t6;
  if ($[2] !== t3) {
    t6 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const requiredFields = t6;
  const showProviderMatcher = t4 === undefined ? false : t4;
  let t7;
  if ($[4] !== onChange) {
    t7 = (fieldKey, value) => {
      onChange(fieldKey, value);
    };
    $[4] = onChange;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const handleFieldChange = t7;
  let t8;
  if ($[6] !== metadata) {
    t8 = fieldKey_0 => getNestedValue(metadata, fieldKey_0 + "_metadata");
    $[6] = metadata;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const getFieldMetadata = t8;
  const hasProviderInfoEnabled = ["givenName", "middleName", "familyName", "specialty", "npiNumber", "ehrId"].some(field => isFieldEnabled(enabledFields, `${providerObjString}.${field}`));
  let t9;
  if ($[8] !== createMode || $[9] !== enabledFields || $[10] !== providerObjString) {
    t9 = createMode && isFieldEnabled(enabledFields, `${providerObjString}.role`);
    $[8] = createMode;
    $[9] = enabledFields;
    $[10] = providerObjString;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const hasRoleEnabled = t9;
  let t10;
  if ($[12] !== errors || $[13] !== getFieldMetadata || $[14] !== handleFieldChange || $[15] !== onFocus || $[16] !== onSave || $[17] !== provider || $[18] !== providerObjString || $[19] !== requiredFields) {
    t10 = t11 => {
      const {
        fieldKey: fieldKey_1,
        label,
        type: t12,
        placeholder,
        editable: t13,
        options
      } = t11;
      const type = t12 === undefined ? "text" : t12;
      const editable = t13 === undefined ? false : t13;
      const value_0 = getNestedValue(provider, fieldKey_1) ?? null;
      const error = getNestedValue(errors, fieldKey_1) ?? null;
      const fullFieldKey = providerObjString ? `${providerObjString}.${fieldKey_1}` : fieldKey_1;
      const isRequired = requiredFields.includes(fullFieldKey);
      if (type === "select" && options) {
        return <div key={fieldKey_1}><SelectWrapper value={value_0} onChange={newValue => handleFieldChange(fieldKey_1, newValue)} label={label} placeholder={placeholder} options={options} />{error && <p className="text-xs text-red-500 mt-1 ml-1">{error}</p>}</div>;
      }
      return <div key={fieldKey_1}><InputWrapper type={type} value={value_0} onChange={e => handleFieldChange(fieldKey_1, e.target.value)} label={label} placeholder={placeholder} isRequired={isRequired} onSave={onSave} onFocus={() => onFocus?.(getFieldMetadata(fieldKey_1))} fieldKey={fullFieldKey} readOnly={!editable} />{error && <p className="text-xs text-red-500 mt-1 ml-1">{error}</p>}</div>;
    };
    $[12] = errors;
    $[13] = getFieldMetadata;
    $[14] = handleFieldChange;
    $[15] = onFocus;
    $[16] = onSave;
    $[17] = provider;
    $[18] = providerObjString;
    $[19] = requiredFields;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const renderField = t10;
  let t11;
  if ($[21] !== createMode || $[22] !== loading || $[23] !== onEmptyToggle || $[24] !== onProviderSelected || $[25] !== practitioners || $[26] !== provider || $[27] !== showProviderMatcher) {
    t11 = (showProviderMatcher || createMode) && onProviderSelected && <div className="flex justify-center items-center mb-4 gap-2"><div className="w-[70%]"><EntityMatcher type="practitioner" existingEntities={createMode ? [] : practitioners} isLoadingExistingEntities={createMode ? false : loading} entity={provider} onEntitySelected={onProviderSelected} showCreateNewOption={createMode} /></div>{onEmptyToggle && <div className="flex items-center gap-2"><Hyperlink onClick={onEmptyToggle} href="#" className="text-xs">Empty</Hyperlink></div>}</div>;
    $[21] = createMode;
    $[22] = loading;
    $[23] = onEmptyToggle;
    $[24] = onProviderSelected;
    $[25] = practitioners;
    $[26] = provider;
    $[27] = showProviderMatcher;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== hasProviderInfoEnabled || $[30] !== hasRoleEnabled || $[31] !== renderField) {
    t12 = hasProviderInfoEnabled && <div><h3 className="text-sm font-semibold mb-3 text-muted-foreground">Provider Information</h3><div className="grid grid-cols-3 gap-4">{renderField({
          fieldKey: "givenName",
          label: "First Name"
        })}{renderField({
          fieldKey: "middleName",
          label: "Middle Name"
        })}{renderField({
          fieldKey: "familyName",
          label: "Last Name"
        })}</div><div className="grid grid-cols-2 gap-4 mt-4">{renderField({
          fieldKey: "specialty",
          label: "Specialty"
        })}{renderField({
          fieldKey: "npiNumber",
          label: "NPI Number"
        })}</div><div className="grid grid-cols-2 gap-4 mt-4">{renderField({
          fieldKey: "ehrId",
          label: "EHR ID",
          editable: true
        })}</div>{hasRoleEnabled && <div className="grid grid-cols-1 gap-4 mt-4">{renderField({
          fieldKey: "role",
          label: "Role",
          type: "select",
          options: enumToOptions(PractitionerRole).filter(_temp)
        })}</div>}</div>;
    $[29] = hasProviderInfoEnabled;
    $[30] = hasRoleEnabled;
    $[31] = renderField;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t11 || $[34] !== t12) {
    t13 = <div className="space-y-6">{t11}{t12}</div>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}
function _temp(option) {
  return option.value !== PractitionerRole.UNKNOWN_PROVIDER;
}